import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectAccountMembershipId, selectIsMini } from '@shared/api/reduxToolkit';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { SidebarNavList } from '@shared/ui/sidebarNavList';
import { TOOLTIP_NAME } from '@shared/ui/tooltip';

import { userNavLib } from '../lib';

export const UserNav = () => {
	const accountMembershipId = useSelector(selectAccountMembershipId);
	const isMini = useSelector(selectIsMini);
	const { t: tT } = useTranslation(i18TranslationNS);
	const links = userNavLib(tT);
	const ariaLabel = tT(Translation.USER_NAV_ARIALABEL);
	const buildPath = ({ to }) =>
		to && accountMembershipId ? `/${accountMembershipId}/${to}` : null;

	return (
		<>
			<SidebarNavList
				items={links}
				ariaLabel={ariaLabel}
				isMini={isMini}
				buildPath={buildPath}
				tooltipName={TOOLTIP_NAME.USERNAV}
			/>
		</>
	);
};
